var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLinescriptIcon = function SvgLinescriptIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M3.403 12.597a.535.535 0 0 0 .015-.722A5.98 5.98 0 0 1 2 8a6 6 0 1 1 6 6H2.604a.25.25 0 0 1-.177-.427zM5.85 8.6c-.138 0-.251.112-.237.25a2.4 2.4 0 0 0 4.774 0c.014-.138-.099-.25-.237-.25z"
  })));
};
export default SvgLinescriptIcon;